module.exports = __webpack_public_path__ + "img/bloody_marry.6bd17a1b.jpg";